import Api from "@/api";
const route = "gfs/communications";

const viewCommunication = async body => {
  const result = await Api.post(`v1/${route}/view`, body);
  return result;
};

const getCommunications = async query => {
  const result = await Api.query(`v1/${route}`, query);
  return result;
};

export default {
  viewCommunication,
  getCommunications
};
